module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/funabashi_ekimae_point1-ef514a44b5cd7f8d8da6ea4ef072ee1d.jpg";